import { useInstantSearch } from 'react-instantsearch-core';

import { isInstantSearchLoading } from '@/utils/algolia';

import { getAllTabTotalHits } from '@/components/Search';
import { SearchNoResults } from '@/components/SearchNoResults';
import type { ContentfulData } from '@/integrations/contentful';

interface NoResultsAllTabProps {
  draftMode: boolean;
  initialCount: number;
  noResultContentData?: ContentfulData[];
}
export const NoResultsAllTab = ({
  draftMode,
  initialCount,
  noResultContentData,
}: NoResultsAllTabProps) => {
  const { scopedResults, status } = useInstantSearch();
  const loading = isInstantSearchLoading(status);

  const countAll = getAllTabTotalHits(scopedResults);

  if (loading || countAll > 0 || initialCount > 0) {
    return null;
  }

  return (
    <SearchNoResults
      data-test-id='NoResultsAllTabSearchNoResults'
      draftMode={draftMode}
      noResultContentData={noResultContentData}
    />
  );
};
